(function () {
    var directivesModule = angular.module('customeDirectivesModule');

    directivesModule.directive('npTreeNav', ['$document', function ($document) {
        return {
            restrict: 'E',
            controller: ['$scope', '$http', '$state', 'pubSub', '$timeout', controller],
            controllerAs: 'vm',
            scope: {
                getSelectedNode: '=',
                template: '=',
                isActiveContainerClass: '=',
                currentNode: '=',
                customCss: '@',
                treeCss: '@',
                isDisabled: '=',
                levelType: '=',
                isShowAll: '='
            },
            templateUrl: '/app/shared/treeNav/tree.tpl.html',
            link: function (scope, element, attr) {
                scope.showFolderTree = false;
                $document.bind('click', function (event) {
                    var isClickedElementChildOfPopup = element
                        .find(event.target)
                        .length > 0;

                    if (isClickedElementChildOfPopup)
                        return;
                    scope.showFolderTree = false;
                    scope.$apply();
                });
            }
        };
    }]);

    function controller($scope, $http, $state, pubSub, $timeout) {
        var vm = this;
        vm.translation = resources;
        vm.clearSelectedFolder = clearSelectedFolder;
        vm.onSearchFolderSelect = onSearchFolderSelect;
        vm.onSearchKeyup = onSearchKeyup;
        var killFolderInformation = null;
        $scope.initialize = function () {
            killFolderInformation = pubSub.subscribe('changeFolderInformation', changeFolderInformation);
            if ($scope.currentNode) {
                onSelectFolder($scope.currentNode);
            }

            $http.get('/api/Folders/GetChildren', { params: { 'Id': null, showDocumentInTree: false } })
                .success(function (data, status, headers, config) {
                    if (!Array.isArray(data))
                        return;

                    if ($scope.isShowAll) {
                        var item = { id: null, name: resources.L.Common.all, type: 0 };
                        data.splice(0, 0, item);

                        vm.selectedFolder = item;
                        onSelectFolder(vm.selectedFolder);
                    }

                    if ($scope.levelType && $scope.levelType >= 0) {
                        $scope.list = getNodesByLevelType(data, $scope.levelType);
                    } else {
                        $scope.list = data;
                    }

                    buildIcons($scope.list);

                })
                .error(function (data, status, headers, config) {
                    $scope.list = null;
                });
        }
        $scope.$on('$destroy', function () {
            killFolderInformation();
        });

        $scope.options = {
            dropped: function (event) {
                console.log('dropped');
            },
            beforeDrop: function (event) {
                console.log('beforeDrop');
            }
        };

        $scope.handleExpand = function (expanded, itemId, selectedNode) {
            if (expanded == true) {

                //sibling is the data which bind with the scope. So if we modify sibling, it will reflect to $scope.list
                var siblings = selectedNode.$parentNodeScope == null ? selectedNode.list : selectedNode.$parentNodeScope.$modelValue.items;
                var modelValue = selectedNode.$modelValue;
                modelValue.expanded = expanded;
                modelValue.class = getIconsWithReadPermission(modelValue);
                //check if type of selected node is in [1, 2, 3, 4] = [Document, LinkDocument, FileDocument, ShortcutDocument] refer to enum NodeType, we dont call request
                if (modelValue.isLoaded || modelValue.type <= 4) {
                    return;
                } else {
                    modelValue.isLoaded = true;
                }

                $http.get('/api/Folders/GetChildren', { params: { 'Id': itemId, showDocumentInTree: false } })
                    .success(function (data, status, headers, config) {
                        if (data != null && data.length > 0 && Array.isArray(data)) {
                            var length = siblings.length;
                            for (var i = 0; i < length; i++) {
                                if (siblings[i].id == itemId) {
                                    if (siblings[i].items == null) {
                                        siblings[i].items = [];
                                    }
                                    buildIcons(data);
                                    if ($scope.levelType && $scope.levelType >= 0) {
                                        data = getNodesByLevelType(data, $scope.levelType);
                                    }
                                    siblings[i].items = siblings[i].items.concat(data);;
                                    break;
                                }
                            }
                        }
                    })
                    .error(function (data, status, headers, config) {
                        // TODO: log error
                    });
            } else {
                var modelValue = selectedNode.$modelValue;
                modelValue.expanded = expanded;
                modelValue.class = getIconsWithReadPermission(modelValue);
            }
        };
        function changeFolderInformation() {
            if ($scope.currentNode) {
                onSelectFolder($scope.currentNode);
            }

            $http.get('/api/Folders/GetChildren', { params: { 'Id': null, showDocumentInTree: false } })
                .then(function (result) {
                    if (!Array.isArray(result.data))
                        return;
                    if ($scope.levelType && $scope.levelType >= 0) {
                        $scope.list = getNodesByLevelType(result.data, $scope.levelType);
                    } else {
                        $scope.list = result.data;
                    }
                    buildIcons($scope.list);
                }, function (reason) {
                    $scope.list = null;
                });
        };
        function getNodesByLevelType(nodes, levelType) {
            var list = [];
            angular.forEach(nodes, function (node) {
                if (node.levelType == levelType) {
                    list.push(node);
                }
            });

            return list;
        };
        $scope.selectNode = function (node, $event) {
            setHighlight($event);
            $scope.showFolderTree = false;
            vm.selectedFolder = node.$modelValue;
            $scope.getSelectedNode(vm.selectedFolder);
            onSelectFolder(vm.selectedFolder);
        }

        $scope.toggle = function (scope) {
            scope.toggle();
        };

        $scope.isFolderNode = function (type) {
            return type == E.nodeTypes.Folder || type == E.nodeTypes.TopFolder || type == E.nodeTypes.DepartmentFolder || type == E.nodeTypes.RegionalFolder;
        };

        function setHighlight(event) {
            $('.angular-ui-tree-handle').removeClass('selected-node');
            $('.selected-node').parent().removeClass('selected-node');
            $(event.target).parent().addClass('selected-node');
        };

        function buildIcons(list) {
            if (!Array.isArray(list)) {
                return;
            }
            var length = list.length;
            for (var i = 0; i < length; i++) {
                list[i].class = getIconsWithReadPermission(list[i]);
            }
        };

        function clearSelectedFolder() {
            $(ELEMENT_SELECTORS.FolderSelectionContainerSelector).removeClass(ELEMENT_SELECTORS.FolderContainerClassSelector);
            vm.selectedFolder = null;
            $scope.getSelectedNode(vm.selectedFolder);
        };

        function onSelectFolder(node) {
            $timeout(function () {
                $(ELEMENT_SELECTORS.FolderSelectionInputSelector).next().toggle(Boolean($(ELEMENT_SELECTORS.FolderSelectionInputSelector).val()));
                $(ELEMENT_SELECTORS.FolderSelectionContainerSelector).addClass(ELEMENT_SELECTORS.FolderContainerClassSelector);
            }, 0, false);
            setFolderSelection(node);
        };

        function setFolderSelection(node) {
            switch (node.type.toString()) {
                case E.nodeTypes.RegionalFolder:
                    angular.element(ELEMENT_SELECTORS.FolderSelectionContainerSelector).removeClass('f-enterprise')
                        .removeClass('f-normal')
                        .removeClass('f-department')
                        .addClass('f-regional visible');
                    break;
                case E.nodeTypes.Folder:
                    angular.element(ELEMENT_SELECTORS.FolderSelectionContainerSelector).removeClass('f-enterprise')
                        .removeClass('f-department')
                        .removeClass('f-regional')
                        .addClass('f-normal visible');
                    break;
                case E.nodeTypes.TopFolder:
                    angular.element(ELEMENT_SELECTORS.FolderSelectionContainerSelector).removeClass('f-normal')
                        .removeClass('f-department')
                        .removeClass('f-regional')
                        .addClass('f-enterprise visible');
                    break;
                case E.nodeTypes.DepartmentFolder:
                    angular.element(ELEMENT_SELECTORS.FolderSelectionContainerSelector).removeClass('f-enterprise')
                        .removeClass('f-normal')
                        .removeClass('f-regional')
                        .addClass('f-department visible');
                    break;
                default:
                    angular.element(ELEMENT_SELECTORS.FolderSelectionContainerSelector).addClass('f-normal visible');
            }
        };

        function onSearchFolderSelect($item, $model, $label) {
            vm.selectedFolder = $item;
            $scope.getSelectedNode(vm.selectedFolder);
            onSelectFolder($item);
        };

        function onSearchKeyup(e) {
            if ((e.which === 8 || e.which == 46)) {
                if ($(e.target).val() == '') {
                    $(ELEMENT_SELECTORS.FolderSelectionContainerSelector).removeClass(ELEMENT_SELECTORS.FolderContainerClassSelector);
                    vm.selectedFolder = null;
                }
            } else {
                if ($(e.target).val() != '') {
                    $timeout(function () {
                        $(ELEMENT_SELECTORS.FolderSelectionInputSelector).next().toggle(Boolean($(ELEMENT_SELECTORS.FolderSelectionInputSelector).val()));
                        $(ELEMENT_SELECTORS.FolderSelectionContainerSelector).addClass(ELEMENT_SELECTORS.FolderContainerClassSelector);
                    }, 0, false);
                }
            }
        };

        $scope.$watch('vm.selectedFolder.name', function (newValue, oldValue) {
            if (newValue != null && newValue.length >= 2 && newValue != oldValue) {
                $http.get('/api/Search/SearchFolders', { params: { 'keyword': newValue } })
                    .then(function (response, status, headers, config) {
                        vm.folders = response.data;
                        buildIcons(vm.folders);
                    });
            }
            if (newValue == null) {
                vm.folders = [];
            }
        });

        $scope.$watch('currentNode', function (newValue, oldValue) {
            if (newValue != null && newValue != oldValue) {
                vm.selectedFolder = newValue;
                onSelectFolder(vm.selectedFolder);
            }
        }, true);

    }

})();